module.exports = "../../app/cells/components/handle_title_segment_cell.rb";